import { useState } from 'react';
import api from '../api/axios';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function Settings() {
  const { admin } = useAuth();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      return toast.error('Passwords do not match');
    }
    if (form.new_password.length < 6) {
      return toast.error('Password must be at least 6 characters');
    }
    setLoading(true);
    try {
      // Note: password change endpoint can be added to backend
      toast.success('Password change will be available after backend endpoint is added');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error('Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Settings</h2>
      </div>

      <div className="card form-card settings-card">
        <h3>Admin Profile</h3>
        <div className="profile-info">
          <div className="profile-avatar">{admin?.name?.charAt(0)}</div>
          <div>
            <p className="profile-name">{admin?.name}</p>
            <p className="profile-email">{admin?.email}</p>
          </div>
        </div>
      </div>

      <div className="card form-card settings-card">
        <h3>Change Password</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Current Password</label>
            <input type="password" value={form.current_password}
              onChange={e => setForm(f => ({ ...f, current_password: e.target.value }))}
              required />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input type="password" value={form.new_password}
              onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))}
              required />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input type="password" value={form.confirm_password}
              onChange={e => setForm(f => ({ ...f, confirm_password: e.target.value }))}
              required />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
